import clsx from 'clsx';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import IconTI from '@components/Images/Rebranding/IconTI';
import useEventTracking from '@hooks/useEventTracking';
import { subscriber_profile_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import { Author } from '../../interfaces/authors';

interface AuthorUnitProps {
  author: Author;
  isRightRail?: boolean;
}

const AuthorUnit = ({
  author: { company, isStaff, name, picture, title, username },
  isRightRail,
}: AuthorUnitProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <a
      href={subscriber_profile_path(username)}
      onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.Author }))}
      className={clsx('flex', {
        'flex-col items-start lg:flex-row lg:items-center': isRightRail,
        'items-center': !isRightRail,
      })}
    >
      <LazyLoadImage
        alt={`${name} headshot`}
        className="rounded-full"
        loading="lazy"
        width={56}
        height={56}
        src={picture}
      />
      <div
        className={clsx('flex flex-col', {
          'ml-0 mt-16 lg:ml-16 lg:mt-0': isRightRail,
          'ml-16': !isRightRail,
        })}
      >
        <span className="flex items-center font-suisse-intl-mono text-disclosure-md text-primary-magenta">
          {name}
          {isStaff && <IconTI className="ml-8 h-16 w-12 text-primary-magenta" />}
        </span>
        {title && (
          <span className="font-suisse-screen text-disclosure-sm text-grayscale-gray">{title}</span>
        )}
        {company && (
          <span className="font-suisse-screen text-disclosure-sm text-grayscale-gray">
            {company}
          </span>
        )}
      </div>
    </a>
  );
};

export default AuthorUnit;
